/*
 * @Description:产品主数据
 * @Author: miaomiao
 * @Date: 2021-01-13 15:25:09
 * @LastEditTime: 2021-06-12 15:08:32
 * @LastEditors: JikeyChang
 */
import dbc from '@/api/masterData/product';

const listData = {
  namespaced: true,
  state: {
    deptTreeLIst: [], // 一级部门二级部门tree
    deptAllTreeList: [{
      id: '',
      name: '湖北亿咖通科技有限公司',
      list: [],
    }], // 公司 + 一级部门二级部门tree
    productLineList: [],
    dictList: [],
    deptUserAllLists: [],
    depList: [],
  },

  actions: {
    // /* 获取部门信息 */
    // getDeptTree(store, param) {
    //   return dbc.getDeptTree(param);
    // },
    /**
     * 获取部门信息
     */
    getDeptTree({ commit }, param) {
      return dbc.getDeptTree(param).then((content) => {
        commit('setDeptTreeLIst', content.list);
      });
    },
    /**
     * 获取产品线列表
     */
    getProLineList({ commit }, param) {
      return dbc.getProLineList(param).then((content) => {
        commit('setProLineLIst', content.list);
      });
    },
    /* 新增产品线 */
    addProLine(store, param) {
      return dbc.addProLine(param);
    },
    /* 产品线排序 */
    updateProLine(store, param) {
      return dbc.updateProLine(param);
    },
    /* 修改产品线 */
    editProLine(store, param) {
      return dbc.editProLine(param);
    },
    /* 获取单条产品线 */
    getOneProLine(store, param) {
      return dbc.getOneProLine(param);
    },
    /* 获取单条产品线树形结构 */
    getProLineTree(store, param) {
      return dbc.getProLineTree(param);
    },
    /* 新增子产品线 */
    addProChildLine(store, param) {
      return dbc.addProChildLine(param);
    },
    /* 修改子产品线 */
    editProChildLine(store, param) {
      return dbc.editProChildLine(param);
    },
    /* 获取单条子产品线 */
    getOneProChildLine(store, param) {
      return dbc.getOneProChildLine(param);
    },
    /* 获取单条产品信息 */
    getOneProMsg(store, param) {
      return dbc.getOneProMsg(param);
    },
    /* 获取单条项目信息 */
    getOneProjectMsg(store, param) {
      return dbc.getOneProjectMsg(param);
    },
    /* 修改产品信息 */
    editProduct(store, param) {
      return dbc.editProduct(param);
    },
    /* 数据字典-PDT和LMT-teamlist */
    getDictList({ commit }, param) {
      return dbc.getDictList(param).then((content) => {
        commit('setDictList', content);
      });
    },
    // 输入名字自动联想
    listByNameLike(store, param) {
      return dbc.listByNameLike(param);
    },
    // 获取部门
    getDepList({ commit }, param) {
      return dbc.getDepList(param).then((content) => {
        commit('setDepList', content);
      });
    },
    proLineExport(store, param) {
      return dbc.proLineExport(param);
    },
  },

  mutations: {
    setDeptTreeLIst(state, list) {
      state.deptTreeLIst = list;
      state.deptAllTreeList[0].list = state.deptTreeLIst;
    },
    setProLineLIst(state, list) {
      state.productLineList = list;
    },
    setDictList(state, content) {
      const { list } = content;
      state.dictList = list;
    },
    setDepList(state, content) {
      const { list } = content;
      state.depList = list;
    },
    setDeptUserAllListTreeVO(state, content) {
      state.deptUserAllLists = content.data || [];
    },
  },
};

export default listData;
